import { useEffect, useState } from "react";
import ChatMessages from "../../components/chatbox/chatMessage";
import ChatSidebar from "../../components/chatbox/chatSidebar";
import ChatUserHead from "../../components/chatbox/chatUserHead";
import { useAxios } from "../../utils/useAxios";
import { useForm } from "react-hook-form";
import { getItem } from "../../utils/storage";
import socket from "../../utils/socket";
import {
  ChatInputIcon,
  EvenoddIcon,
  MicCion,
  SentIcon,
} from "../../components/icons/icons";

interface Message {
  id: number;
  senderId: number;
  content: string;
  timestamp: string;
}

type FormValues = {
  messagesInput: string;
};

// function MapComponent() {
//   const embedCode = `<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d438.2888193207691!2d77.0727327173332!3d28.500302815852944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjjCsDMwJzAxLjYiTiA3N8KwMDQnMjIuNyJF!5e0!3m2!1sen!2sin!4v1745248091911!5m2!1sen!2sin" width="600" height="450" style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>`;

//   return (
//     <div style={{ width: "100%", height: "400px" }}>
//       <div dangerouslySetInnerHTML={{ __html: embedCode }} />
//     </div>
//   );
// }

const Chat = () => {
  const { register, handleSubmit, reset } = useForm<FormValues>();

  const [chatId, setChatId] = useState<number | null>(null);
  // const [currentUserId, setCurrentUserId] = useState<number | null>(null);
  const [messages, setMessages] = useState<Message[]>([]);
  // const [input, setInput] = useState("");
  // const flatListRef = useRef<FlatList<Message> | null>(null);

  const [isSending, setIsSending] = useState(false);

  const {
    res: getdriverRes,
    mutate: getdriverMatate,
    isPending: getdriverIsPending,
    error: getdriverError,
  } = useAxios({
    url: "/api/auth/get_chat_drivers",
  });
  useEffect(() => {
    getdriverMatate({});
  }, []);

  const { res, mutate } = useAxios({
    url: `/api/auth/chatpost`,
  });

  useEffect(() => {
    mutate({ loadId: 1003 });
  }, []);

  useEffect(() => {
    if (res?.data?.chat?.id) {
      setChatId(res.data.chat.id);
      setMessages(res.data.chat.messages || []);
    }
  }, [res]);

  const { res: res_message, mutate: mutate_message } = useAxios({
    url: `/api/auth/sendmessage`,
  });

  const user = getItem("user");

  const onSubmit = (data: FormValues) => {
    const messagePayload = {
      chatId: res?.data?.chat?.id,
      content: data.messagesInput,
      senderId: user?.user?.id,
    };

    mutate_message(messagePayload, {
      onSuccess: (response: any) => {
        socket.emit("sendMessage", response?.data?.data); // Emit the actual message
        //setMessages((prev) => [...prev, response?.data?.data]); // Optimistically add it
        setIsSending(false);
      },
      onError: () => {
        setIsSending(false);
      },
    });

    setIsSending(true);
    reset();
  };

  useEffect(() => {
    if (!socket) return;

    const handleMessage = (message: any) => {
      setMessages((prev) => [...prev, message]);
    };

    socket.on("messageReceived", handleMessage);

    return () => {
      socket.off("messageReceived", handleMessage); // ✅ Clean up
    };
  }, [socket]);
  //   sendmessage

  useEffect(() => {
    if (chatId) {
      socket.emit("joinRoom", chatId); // 👈 Join the room
    }
  }, [chatId]);
  return (
    <>
      <div className="h-[calc(100vh-150px)] overflow-hidden sm:h-[calc(100vh-174px)]">
        <div className="flex flex-col h-full gap-6 xl:flex-row xl:gap-5">
          <ChatSidebar
            setSelectedDriver={""}
            driverslist={getdriverRes?.data?.data}
          />
          <div className="flex h-full flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] xl:w-3/4">
            <ChatUserHead profile={messages} />
            <ChatMessages messages={messages} />
            <div className="sticky bottom-0 p-3 border-t border-gray-200 dark:border-gray-800">
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="flex items-center justify-between"
              >
                <div className="relative w-full">
                  <button className="absolute text-gray-500 -translate-y-1/2 left-1 top-1/2 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white/90 sm:left-3">
                    <ChatInputIcon />
                  </button>
                  <input
                    {...register("messagesInput", { required: true })}
                    onChange={(e) => {
                      socket.emit("typing", {
                        chatId,
                        senderId: user?.user?.id,
                      });
                    }}
                    placeholder="Type a message"
                    className="w-full pl-12 pr-5 text-sm text-gray-800 bg-transparent border-none outline-hidden h-9 placeholder:text-gray-400 focus:border-0 focus:ring-0 dark:text-white/90"
                    type="text"
                  />
                </div>
                <div className="flex items-center">
                  <button className="mr-2 text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white/90">
                    <EvenoddIcon />
                  </button>
                  <button className="text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white/90">
                    <MicCion />
                  </button>
                  <button
                    disabled={isSending}
                    type="submit"
                    className="flex items-center justify-center ml-3 text-white rounded-lg h-9 w-9 bg-brand-500 hover:bg-brand-600 xl:ml-5"
                  >
                    <SentIcon />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* <div>
          <MapComponent />
        </div> */}
      </div>
    </>
  );
};

export default Chat;
